export default "__VITE_ASSET__qvuPAteo__"